import { Flex, Skeleton, Title, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useEffect, useState } from "react";

import type { Leader_Board, TransformedLeaderboard } from "~/core";

import { LeaderBoardTable } from "./components/LeaderBoardTable";

export type LeaderBoardProps = {
  data: Leader_Board;
  fetchSpreadsheet: (data: Leader_Board) => Promise<TransformedLeaderboard>;
};

export const LeaderBoard: FC<LeaderBoardProps> = ({
  data,
  fetchSpreadsheet,
}) => {
  const [spreadsheet, setSpreadsheetData] =
    useState<TransformedLeaderboard | null>(null);

  useEffect(() => {
    fetchSpreadsheet(data)
      .then((res) => {
        setSpreadsheetData(res);
      })
      .catch((e) => {
        console.error(e);
      });
  }, [setSpreadsheetData, fetchSpreadsheet]);

  return (
    <Flex
      flexDirection="column"
      align="center"
      width="100%"
      m={{ mx: "auto" }}
      p={{ py: 40 }}
      md={{ p: { py: 80 } }}
    >
      {data?.title && (
        <Title
          as="h2"
          fontWeight="mobile.bold"
          size="small"
          horizontalAlign="center"
          md={{ weight: "semibold", size: "large" }}
          data-testid="leader-board-title"
        >
          {data.title}
        </Title>
      )}
      {data?.description && (
        <Typography
          horizontalAlign="center"
          size="large"
          m={{ mt: 8, mb: 24 }}
          data-testid="leader-board-description"
        >
          {data.description}
        </Typography>
      )}

      {spreadsheet ? (
        <LeaderBoardTable {...spreadsheet} />
      ) : (
        <Skeleton radius={4} height={470} width="100%" md={{ maxWidth: 700 }} />
      )}
    </Flex>
  );
};
